import { makeStyles } from "@material-ui/core/styles";

export const styleDropzone = makeStyles({
  base: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: 230,
    marginBottom: 16,
    backgroundColor: "#fafafa",
    border: "1px dashed #d9d9d9",
    borderRadius: 4,
    outline: "none",
    cursor: "pointer",
  },
  activeStyle: {
    borderColor: "#2196f3",
  },
  acceptStyle: {
    borderColor: "#00e676",
  },
  rejectStyle: {
    borderColor: "#ff1744",
  },
  icon: {
    fontSize: 48,
    color: "#40a9ff",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    color: "#414141",
    textAlign: "center",
  },
  error: {
    color: "#dc3545",
  },
  button: {
    marginTop: 16,
    fontSize: 12,
    textTransform: "none",
  },
  buttonSecondary: {
    marginTop: 5,
    fontSize: 12,
    textTransform: "none",
  },
});

export const styleBackdrop = makeStyles((theme) => ({
  base: {
    display: "flex",
    flexDirection: "column",
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  icon: {
    position: "absolute",
  },
  value: {
    color: "#fff",
  },
  text: {
    position: "absolute",
    marginTop: 48,
    fontSize: 14,
  },
  text2: {
    position: "absolute",
    marginTop: 88,
    fontSize: 14,
  },
}));
